import React, { useCallback } from "react";
import { toast } from "react-toastify";
import { notifyGoogleAccountAssociated } from "../../../api/user";
import { GOOGLE_ACCOUNT_CONNECT_VIDEO_TYPE } from "../../../api/videoApi";
import { useVideoByType } from "../../../hooks/react-query/video/useVideoByType";

const GOOGLE_SIGNUP_URL = "http://accounts.google.com/signupwithoutgmail";

// "already associated" reuses IgniteNissanPdf.tsx's own handleSubmitAccess - same
// notifyGoogleAccountAssociated call/toast behavior as that page's top button (formerly at
// /global_ms_sales/pdf_page, now /faq/link_google_account). The `dashboard` query param that
// endpoint takes is inert server-side today (routes/user.py's handler doesn't read it at all), so
// "faq" here is just for readability in logs/telemetry, not a behavioral choice.
export const GoogleConnectTileContent = () => {
  const { playbackUrl } = useVideoByType(GOOGLE_ACCOUNT_CONNECT_VIDEO_TYPE);

  const handleAlreadyAssociated = useCallback(() => {
    notifyGoogleAccountAssociated("faq")
      .then((response) => {
        if (response?.error) {
          toast.error("Failed to update your request, please try again later");
        } else {
          toast.success("Request for access has been received");
        }
      })
      .catch(() => {
        toast.error("Failed to update your request, please try again later");
      });
  }, []);

  return (
    <>
      <p>Watch the step-by-step video below or follow these guidelines:</p>
      <ol className="faq_numbered_list">
        <li>
          Click on the Google Account button below and you will be redirected to Google. Select the corporate Google account
          (@mail.nissan.co.jp or regional equivalent) you want to link.
        </li>
        <li>
          Review the permissions requested and click Allow. CEDAR only requests your name and email — no access to Drive, Mail or
          Calendar.
        </li>
        <li>
          Return to CEDAR Home to confirm you have associated your account using the button below. CEDAR should provide you access
          within 2-3 working days.
        </li>
      </ol>
      <div className="faq_button_row">
        <a
          className="faq_button_primary"
          href={GOOGLE_SIGNUP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-test-id="google-account-button"
        >
          Google Account
        </a>
        <button className="faq_button_primary" onClick={handleAlreadyAssociated} data-test-id="already-associated-button">
          I have already associated my Nissan ID to Google
        </button>
      </div>
      {playbackUrl && (
        <video className="faq_video_embed" src={playbackUrl} controls playsInline data-test-id="google-connect-video" />
      )}
    </>
  );
};
